import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ValuationSubmission } from './components/plate-x-val-band/plate-x-val-band.component';
import { ScenarioTrailItem } from './models/sell.models';
import { MarketPulseService } from '../../services/market-pulse.service';
import { MarketPulseSoldExample } from '../../models/market-pulse.model';

@Component({
  selector: 'pla-sell',
  templateUrl: './sell.component.html',
  styleUrls: ['./sell.component.scss'],
})
export class SellComponent implements OnInit {
  readonly heroImage: string = '/assets/sell/hero_car.jpg';

  // Scenario A — CAS 5H cash-bid route. Two dealer cash bids land within days; seller
  // accepts the higher one (£7,300) and DVLA transfer completes in 9 days.
  readonly cas5HTrail: ScenarioTrailItem[] = [
    { text: 'Bid \u00A35,600' },
    { text: 'Bid \u00A37,300' },
    { text: 'Accept \u00A37,300' },
    { text: 'Sold \u00A37,300', final: true },
  ];

  // Scenario B — M42 KET listing route. No cash bid; routed to a listing dealer who
  // markets the plate on their site and sells at retail over a longer horizon.
  readonly m42KetTrail: ScenarioTrailItem[] = [
    { text: 'Listed' },
    { text: 'Dealer marketing' },
    { text: 'Buyer found' },
    { text: 'Sold \u00A38,700', final: true },
  ];

  soldExample: MarketPulseSoldExample | null = null;

  constructor(private router: Router, private marketPulse: MarketPulseService) {}

  ngOnInit(): void {
    this.marketPulse.getMarketPulse().subscribe((res) => {
      this.soldExample = res?.soldExample ?? null;
    });
  }

  onValuationSubmitted(submission: ValuationSubmission): void {
    const reg = encodeURIComponent(submission.registration);
    this.router.navigate(['/sell/valuation', reg]);
  }
}
